import moment from "moment";
import { useMediaQuery } from "react-responsive";
export const formatDate = (date, time) => {
  const _date = new Date(date);
  function addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  // const days = [
  //   "Monday",
  //   "Tuesday",
  //   "Wednesday",
  //   "Thursday",
  //   "Friday",
  //   "Saturday",
  //   "Sunday",
  // ];
  const month = _date?.getMonth();
  const day = _date?.getDate();
  const year = _date?.getFullYear();
  const hours = addZero(_date?.getHours());
  const minutes = addZero(_date?.getMinutes());
  return `${months[month]} ${day}, ${year} ${
    time ? `${hours}:${minutes}` : ""
  }`;
};

export const convertTime = (seconds) => {
  if (!isNaN(seconds)) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    if (parseInt(mins) < 10 && secs < 10) {
      return `0${mins}:0${secs}`;
    } else if (parseInt(mins) < 10) {
      return `0${mins}:${secs}`;
    } else if (secs < 10) return `${mins}:0${secs}`;
    else return `${mins}:${secs}`;
  }
};

export const dateFormat = (locale) => {
  const _date = new Date();
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const month = _date?.getMonth();
  const day = _date?.getDate();
  const year = _date?.getFullYear();

  return locale === "en"
    ? `${days[_date.getDay() - 1]}, ${months[month]} ${day}, ${year}`
    : `${moment(new Date())?.format('DD.MM.YYYY | HH:mm')}`;
};
export const getGermanMonths = (date) => {
  const _date = new Date(date);

  const deMonths = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ];

  const month = _date.getMonth();

  return `${deMonths[month].slice(0, 3)}`;
};
export const useCustomMediaQuery = () => {
  const isXsScreen = useMediaQuery({ maxWidth: 575 });
  const isSmScreen = useMediaQuery({ minWidth: 576, maxWidth: 767 });
  const isMdScreen = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isLgScreen = useMediaQuery({ minWidth: 992, maxWidth: 1199 });
  const isXLgScreen = useMediaQuery({ minWidth: 1200, maxWidth: 1399 });
  const isXxLgScreen = useMediaQuery({ minWidth: 1400 });
  const resolution = isXsScreen
    ? "256x144"
    : isSmScreen
    ? "512x288"
    : isMdScreen
    ? "1024x576"
    : isLgScreen
    ? "1024x576"
    : "1024x576";
  return {
    isXsScreen,
    isSmScreen,
    isMdScreen,
    isLgScreen,
    isXLgScreen,
    isXxLgScreen,
    resolution,
  };
};

export const bytesToSize = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const openLink = (link, target = "_blank") => {
  setTimeout(() => {
    window.open(link, target);
  });
};
